import { render, staticRenderFns } from "./_base-tree-select.vue?vue&type=template&id=059fec4e&scoped=true&"
import script from "./_base-tree-select.vue?vue&type=script&lang=js&"
export * from "./_base-tree-select.vue?vue&type=script&lang=js&"
import style0 from "./_base-tree-select.vue?vue&type=style&index=0&id=059fec4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fec4e",
  null
  
)

export default component.exports